export default __webpack_public_path__ + "static/media/thumbnail_image_3.c67f414d.png";